module.exports = __webpack_public_path__ + "img/img34.7fc55975.svg";